/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {ProductionHistory} from '../bioplanModels';
// @ts-ignore
import type {ProductionHistoryStats} from '../bioplanModels';
/**
 * ProductionHistoryApi - axios parameter creator
 * @export
 */
export const ProductionHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete all production history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/productionHistory/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export production history to an Excel file
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {ProductionHistoryExportGetFileFormatEnum} [fileFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryExportGet: async (
      startDate?: string,
      endDate?: string,
      fileFormat?: ProductionHistoryExportGetFileFormatEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/productionHistory/export`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (fileFormat !== undefined) {
        localVarQueryParameter['fileFormat'] = fileFormat;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Import production history from Fishtalk
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryFishtalkPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists('productionHistoryFishtalkPost', 'file', file);
      const localVarPath = `/productionHistory/fishtalk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Import production history using Bioplan generic format
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryGenericPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists('productionHistoryGenericPost', 'file', file);
      const localVarPath = `/productionHistory/generic`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all production history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/productionHistory/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Import production history from Mercatus
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryMercatusPost: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists('productionHistoryMercatusPost', 'file', file);
      const localVarPath = `/productionHistory/mercatus`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get production history statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryStatsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/productionHistory/stats`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProductionHistoryApi - functional programming interface
 * @export
 */
export const ProductionHistoryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProductionHistoryApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete all production history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productionHistoryDelete(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productionHistoryDelete(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProductionHistoryApi.productionHistoryDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Export production history to an Excel file
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {ProductionHistoryExportGetFileFormatEnum} [fileFormat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productionHistoryExportGet(
      startDate?: string,
      endDate?: string,
      fileFormat?: ProductionHistoryExportGetFileFormatEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productionHistoryExportGet(
        startDate,
        endDate,
        fileFormat,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProductionHistoryApi.productionHistoryExportGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Import production history from Fishtalk
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productionHistoryFishtalkPost(
      file: File,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productionHistoryFishtalkPost(file, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProductionHistoryApi.productionHistoryFishtalkPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Import production history using Bioplan generic format
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productionHistoryGenericPost(
      file: File,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productionHistoryGenericPost(file, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProductionHistoryApi.productionHistoryGenericPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all production history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productionHistoryGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionHistory>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productionHistoryGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProductionHistoryApi.productionHistoryGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Import production history from Mercatus
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productionHistoryMercatusPost(
      file: File,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productionHistoryMercatusPost(file, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProductionHistoryApi.productionHistoryMercatusPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get production history statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async productionHistoryStatsGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionHistoryStats>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.productionHistoryStatsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProductionHistoryApi.productionHistoryStatsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ProductionHistoryApi - factory interface
 * @export
 */
export const ProductionHistoryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ProductionHistoryApiFp(configuration);
  return {
    /**
     *
     * @summary Delete all production history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryDelete(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.productionHistoryDelete(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Export production history to an Excel file
     * @param {ProductionHistoryApiProductionHistoryExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryExportGet(
      requestParameters: ProductionHistoryApiProductionHistoryExportGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .productionHistoryExportGet(
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.fileFormat,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Import production history from Fishtalk
     * @param {ProductionHistoryApiProductionHistoryFishtalkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryFishtalkPost(
      requestParameters: ProductionHistoryApiProductionHistoryFishtalkPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .productionHistoryFishtalkPost(requestParameters.file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Import production history using Bioplan generic format
     * @param {ProductionHistoryApiProductionHistoryGenericPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryGenericPost(
      requestParameters: ProductionHistoryApiProductionHistoryGenericPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .productionHistoryGenericPost(requestParameters.file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all production history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProductionHistory>> {
      return localVarFp.productionHistoryGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Import production history from Mercatus
     * @param {ProductionHistoryApiProductionHistoryMercatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryMercatusPost(
      requestParameters: ProductionHistoryApiProductionHistoryMercatusPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .productionHistoryMercatusPost(requestParameters.file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get production history statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    productionHistoryStatsGet(options?: RawAxiosRequestConfig): AxiosPromise<ProductionHistoryStats> {
      return localVarFp.productionHistoryStatsGet(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for productionHistoryExportGet operation in ProductionHistoryApi.
 * @export
 * @interface ProductionHistoryApiProductionHistoryExportGetRequest
 */
export interface ProductionHistoryApiProductionHistoryExportGetRequest {
  /**
   *
   * @type {string}
   * @memberof ProductionHistoryApiProductionHistoryExportGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof ProductionHistoryApiProductionHistoryExportGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {'csv' | 'excel'}
   * @memberof ProductionHistoryApiProductionHistoryExportGet
   */
  readonly fileFormat?: ProductionHistoryExportGetFileFormatEnum;
}

/**
 * Request parameters for productionHistoryFishtalkPost operation in ProductionHistoryApi.
 * @export
 * @interface ProductionHistoryApiProductionHistoryFishtalkPostRequest
 */
export interface ProductionHistoryApiProductionHistoryFishtalkPostRequest {
  /**
   *
   * @type {File}
   * @memberof ProductionHistoryApiProductionHistoryFishtalkPost
   */
  readonly file: File;
}

/**
 * Request parameters for productionHistoryGenericPost operation in ProductionHistoryApi.
 * @export
 * @interface ProductionHistoryApiProductionHistoryGenericPostRequest
 */
export interface ProductionHistoryApiProductionHistoryGenericPostRequest {
  /**
   *
   * @type {File}
   * @memberof ProductionHistoryApiProductionHistoryGenericPost
   */
  readonly file: File;
}

/**
 * Request parameters for productionHistoryMercatusPost operation in ProductionHistoryApi.
 * @export
 * @interface ProductionHistoryApiProductionHistoryMercatusPostRequest
 */
export interface ProductionHistoryApiProductionHistoryMercatusPostRequest {
  /**
   *
   * @type {File}
   * @memberof ProductionHistoryApiProductionHistoryMercatusPost
   */
  readonly file: File;
}

/**
 * ProductionHistoryApi - object-oriented interface
 * @export
 * @class ProductionHistoryApi
 * @extends {BaseAPI}
 */
export class ProductionHistoryApi extends BaseAPI {
  /**
   *
   * @summary Delete all production history
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductionHistoryApi
   */
  public productionHistoryDelete(options?: RawAxiosRequestConfig) {
    return ProductionHistoryApiFp(this.configuration)
      .productionHistoryDelete(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Export production history to an Excel file
   * @param {ProductionHistoryApiProductionHistoryExportGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductionHistoryApi
   */
  public productionHistoryExportGet(
    requestParameters: ProductionHistoryApiProductionHistoryExportGetRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return ProductionHistoryApiFp(this.configuration)
      .productionHistoryExportGet(
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.fileFormat,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Import production history from Fishtalk
   * @param {ProductionHistoryApiProductionHistoryFishtalkPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductionHistoryApi
   */
  public productionHistoryFishtalkPost(
    requestParameters: ProductionHistoryApiProductionHistoryFishtalkPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductionHistoryApiFp(this.configuration)
      .productionHistoryFishtalkPost(requestParameters.file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Import production history using Bioplan generic format
   * @param {ProductionHistoryApiProductionHistoryGenericPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductionHistoryApi
   */
  public productionHistoryGenericPost(
    requestParameters: ProductionHistoryApiProductionHistoryGenericPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductionHistoryApiFp(this.configuration)
      .productionHistoryGenericPost(requestParameters.file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all production history
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductionHistoryApi
   */
  public productionHistoryGet(options?: RawAxiosRequestConfig) {
    return ProductionHistoryApiFp(this.configuration)
      .productionHistoryGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Import production history from Mercatus
   * @param {ProductionHistoryApiProductionHistoryMercatusPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductionHistoryApi
   */
  public productionHistoryMercatusPost(
    requestParameters: ProductionHistoryApiProductionHistoryMercatusPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductionHistoryApiFp(this.configuration)
      .productionHistoryMercatusPost(requestParameters.file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get production history statistics
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductionHistoryApi
   */
  public productionHistoryStatsGet(options?: RawAxiosRequestConfig) {
    return ProductionHistoryApiFp(this.configuration)
      .productionHistoryStatsGet(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const ProductionHistoryExportGetFileFormatEnum = {
  Csv: 'csv',
  Excel: 'excel',
} as const;
export type ProductionHistoryExportGetFileFormatEnum =
  (typeof ProductionHistoryExportGetFileFormatEnum)[keyof typeof ProductionHistoryExportGetFileFormatEnum];
